export const getRaceKey = "getRace";
export const getCategoriesKey = "getCategories";
export const getCurrentPriceKey = "getCurrentPrices";
